exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#raw_output[data-v-33402626] {\n  width: 100%;\n  padding: 64px;\n  margin: 32px 0;\n  border: 1px solid #c1c6d1;\n  border-radius: 4px;\n  font-family: \"Courier New\", monospace;\n  background-color: #3c4151;\n  color: #fff;\n  height: 200px;\n}\n", ""]);

// exports
